import React from "react";
import { Dialog, MenuItem, withStyles } from "@material-ui/core";
import "../../styles/sharedStyles.scss";
import Grid from "@material-ui/core/Grid";
import Clear from "@material-ui/icons/Clear";
import dealerSetupDialogStyles from "./DealerSetupDialog.module.scss";
import subNavStyles from "../../shared/subnav/subNavStyles";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import Button from "@material-ui/core/Button";
import { withTranslation } from "react-i18next";
import { KeyboardArrowDown } from "@material-ui/icons";

const StyledSelect = withStyles({
  select: {
    width: "100%",
    boxSizing: "border-box",
    paddingTop: 5,
    paddingBottom: 5,
    paddingLeft: 10,
    paddingRight: 10,
    fontSize: 14,
    color: "$4a4a4a",
    lineHeight: 1.57,
    letterSpacing: 1.5,
    fontFamily: "FordAntenna-Regular, sans-serif",
  },
})(Select);

const StyledClear = withStyles({
  root: {
    width: 27,
    height: 27,
    fill: "#102b4e",
    align: "right",
  },
})(Clear);

const StyledMenuItem = withStyles({
  root: {
    paddingTop: 5,
    paddingBottom: 5,
    paddingLeft: 10,
    paddingRight: 10,
    margin: 0,
    fontSize: 14,
    color: "#102b4e",
    lineHeight: 1.57,
    letterSpacing: 1.5,
    fontFamily: "FordAntenna-Regular, sans-serif",
    "&:hover": {
      backgroundColor: "#102b4e",
      color: "white",
    },
  },
})(MenuItem);

const StyledDialog = withStyles({
  paper: {
    width: 700,
    maxWidth: 700,
  },
})(Dialog);

const StyledGrid = withStyles({
  root: {
    width: 700,
    maxWidth: 700,
  },
  container: {
    width: 700,
    maxWidth: 700,
  },
})(Grid);

class DealerSetupDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dropDownValue: this.props.t("EmpMembership.dealerSetupDialogSelectText"),
    };
  }

  handleDealerSetupDialogConfirm = () => {
    this.props.handleDealerSetupDialogConfirm(
      this.state.dropDownValue,
      this.props.dealer.completeDealerId
    );
  };

  getMenuItem(key, message, dealerId) {
    return (
      <StyledMenuItem data-testid={key} id={key} value={key} key={key}>
        <div>
          {dealerId} | {message}
        </div>
      </StyledMenuItem>
    );
  }

  updateDropdown = (event) => {
    this.setState({ dropDownValue: event.target.value });
  };

  render() {
    const isFromNscDealerSearch =
      this.props.user.permissions.rolePermissions.hasOwnProperty(
        "dealerParticipationSubmit"
      ) && this.props.fromNscDealerSearch;
    return (
      <StyledDialog
        open={this.props.open}
        className={dealerSetupDialogStyles.dialog}
        onClose={this.props.onClose}
      >
        <StyledGrid
          container
          data-testid="dealerSetupDialog"
          id="dealerSetupDialog"
          className={dealerSetupDialogStyles.dialogContainer}
          justify="center"
        >
          <Grid item md={12} className={dealerSetupDialogStyles.cancel}>
            <div>
              <button
                name="dealerSetupDialogCloseName"
                data-testid="dealerSetupDialogCloseTestId"
                id="dealerSetupDialogCloseTestId"
                onClick={this.props.onClose}
              >
                <StyledClear />
              </button>
            </div>
          </Grid>

          <Grid item md={9}>
            <div className={dealerSetupDialogStyles.dialogTitle}>
              <div>{this.props.dialogProps.title}</div>
            </div>
          </Grid>

          <Grid item md={9}>
            <div className={dealerSetupDialogStyles.dialogDescription}>
              {this.props.dialogProps.body}
            </div>
          </Grid>

          <Grid
            item
            md={9}
            className={`${dealerSetupDialogStyles.dropdown} ${dealerSetupDialogStyles.dealerSetupConfirm}`}
          >
            <div className={dealerSetupDialogStyles.dropdownDiv}>
              <div className={dealerSetupDialogStyles.dropdownTitle}>
                {this.state.dropDownValue !== undefined &&
                this.state.dropDownValue !== "" &&
                this.state.dropDownValue !==
                  this.props.t("EmpMembership.dealerSetupDialogSelectText")
                  ? this.props.dialogProps.dropDownTitle
                  : ""}
              </div>
              <FormControl id="dealerSetupFormControl" fullWidth={true}>
                <StyledSelect
                  IconComponent={() => (
                    <KeyboardArrowDown style={subNavStyles.icon} />
                  )}
                  name="dealerSetupDropDownName"
                  data-testid="dealerSetupDropDownId"
                  id="dealerSetupDropDownId"
                  className={dealerSetupDialogStyles.dealerSetupDropDownStyle}
                  value={this.state.dropDownValue}
                  onClick={(event) => this.updateDropdown(event)}
                >
                  <StyledMenuItem
                    data-testid="select"
                    id="select"
                    value={this.props.t(
                      "EmpMembership.dealerSetupDialogSelectText"
                    )}
                    key="select"
                  >
                    <div>{this.props.dialogProps.dropDownTitle}</div>
                  </StyledMenuItem>
                  {this.props.similarDealers
                    ? this.props.similarDealers.map((item) => {
                        return this.getMenuItem(
                          item.id,
                          item.name,
                          item.dealerId
                        );
                      })
                    : null}
                </StyledSelect>
              </FormControl>
            </div>
          </Grid>

          <Grid item md={9}>
            <div className={dealerSetupDialogStyles.dealerSetupConfirm}>
              <Button
                className={dealerSetupDialogStyles.setUpMembership}
                name="dealerSetupConfirmName"
                data-testid="dealerSetupConfirmId"
                id="dealerSetupConfirmId"
                disabled={
                  this.state.dropDownValue === undefined ||
                  this.state.dropDownValue === "" ||
                  this.state.dropDownValue ===
                    this.props.t("EmpMembership.dealerSetupDialogSelectText") ||
                  this.props.disabledButton ||
                  isFromNscDealerSearch
                }
                onClick={() =>
                  this.handleDealerSetupDialogConfirm(this.state.dropDownValue)
                }
              >
                {this.props.dialogProps.confirm}
              </Button>
            </div>
          </Grid>
        </StyledGrid>
      </StyledDialog>
    );
  }
}

export default withTranslation("emp")(DealerSetupDialog);
